import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import bundleActions from '@redux/bundle/actions';
import { RootState } from '@redux/reducer';

const { fetchBundleEnrollmentAction } = bundleActions;

const useBundleEnrollment = () => {
  const dispatch = useDispatch();
  const { bundleEnrollmentState } = useSelector((state: RootState) => ({
    bundleEnrollmentState: state.Bundle.get('bundleEnrollmentState'),
  }));

  const { data: bundleEnrollmentData, isLoading: isBundleEnrollmentLoading } = bundleEnrollmentState;

  const handleFetchBundleEnrollment = (bundleIdOrIdName: string) => {
    dispatch(fetchBundleEnrollmentAction.request({ bundleIdOrIdName }));
  };

  const handleResetBundleEnrollment = () => {
    dispatch(fetchBundleEnrollmentAction.reset());
  };

  const { bundleEnrollmentStatus, hasEnrolled } = useMemo(() => {
    return {
      bundleEnrollmentStatus: bundleEnrollmentData?.enrollmentStatus,
      hasEnrolled: bundleEnrollmentData?.hasEnrolled,
    };
  }, [bundleEnrollmentData]);

  return {
    bundleEnrollmentStatus,
    hasEnrolled,
    isBundleEnrollmentLoading,
    handleFetchBundleEnrollment,
    handleResetBundleEnrollment,
  };
};

export default useBundleEnrollment;
